import React, { Component } from 'react'

export class Footer extends Component {
  render() {
    return (
      <div className='footer'>
      <footer>
        <h2>&copy; 2026 GitPeek</h2>
        <a href='https://github.com/a1ferov/GitPeek/' target='_blank' rel='noopener noreferrer'>GitPeek repositories</a>
      </footer>
      </div>
    )
  }
}   

export default Footer